export default "__VITE_ASSET__0c507572__"